/**
 * CRM activity / audit / calendar POC — Matthew Lynch (CEO) only.
 * Other users keep today's tracker, edit-log, and calendar behavior unchanged.
 */

/** Canonical CEO email for Matthew Lynch (MJL Enterprises / LCTF). */
export const CRM_ACTIVITY_POC_CEO_EMAIL = 'mjl@lctimberframes.com';

/**
 * Single allowlist gate for all POC behavior (enhanced idle clock, unified
 * sessions, edit audit stamps, calendar sync eligibility on the client).
 * Match by email (case-insensitive) and/or Firebase uid when known.
 */
export const CRM_ACTIVITY_POC_ALLOWLIST = {
  emails: [CRM_ACTIVITY_POC_CEO_EMAIL] as readonly string[],
  /** Optional Firebase Auth uids; email match is enough when uid is unknown in repo config. */
  uids: [] as readonly string[],
  /** Display-name fallback when a write path only has actorName (e.g. purchasing). */
  displayNames: ['Matthew Lynch', 'Matt Lynch'] as readonly string[],
} as const;

export function normalizeCrmActivityPocEmail(email?: string | null): string {
  return (email || '').trim().toLowerCase();
}

function normalizeDisplayName(name?: string | null): string {
  return (name || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export function isCrmActivityPocUser(identity?: {
  email?: string | null;
  uid?: string | null;
  id?: string | null;
  name?: string | null;
  displayName?: string | null;
} | null): boolean {
  if (!identity) return false;
  const uid = (identity.uid || identity.id || '').trim();
  if (uid && CRM_ACTIVITY_POC_ALLOWLIST.uids.includes(uid)) return true;
  const email = normalizeCrmActivityPocEmail(identity.email);
  if (
    email
    && CRM_ACTIVITY_POC_ALLOWLIST.emails.some(
      (allowed) => normalizeCrmActivityPocEmail(allowed) === email,
    )
  ) {
    return true;
  }
  const name = normalizeDisplayName(identity.name || identity.displayName);
  if (
    name
    && CRM_ACTIVITY_POC_ALLOWLIST.displayNames.some(
      (allowed) => normalizeDisplayName(allowed) === name,
    )
  ) {
    return true;
  }
  return false;
}
